import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ToasterService } from '../services/toastr.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private _authService: AuthService,
    private _toasterService: ToasterService,
    private _translateService: TranslateService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (state.url.includes('/auth/login')) {
      if (this._authService.isAuthenticated()) {
        this.router.navigate(['/dashboard']);
        return false;
      } else {
        return true;
      }
    } else {
      if (!this._authService.isAuthenticated()) {
        this.router.navigate(['/auth/login']);
        this._toasterService.errToastr(
          this._translateService.instant('LoginFirst')
        );
        return false;
      } else {
        return true;
      }
    }
  }
}
